// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .particularCategoryContainerCFS{
  display: flex;
  justify-content: flex-start;
  overflow-x: auto !important;
  margin-bottom: 0.5rem !important;
  padding: 0.5rem !important;
  gap: 7px !important;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.particularCategoryContainerCFS::-webkit-scrollbar {
    display: none;
}

.particularCategoryContainerCFS::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}
.particularCategoryContainerCFS::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #cbcbcb;
}

.light .particularCustomerDivCategoryCFS:focus {
  outline: none;
}

.dark .particularCustomerDivCategoryCFS:focus {
  outline: none;
}

.particularCustomerDivCategoryCFS{
  border-radius: 5px;
  font-size: 0.813rem !important;
  font-weight: 400 !important;
  border: 1px solid #2A71FF;
  color: #2A71FF !important;
  display: flex;
  text-align: center !important;
  align-items: center !important;
  min-width: fit-content !important;
  cursor: pointer;
}

.particularCategoryContainerCFS .particularCustomerDivCategoryCFS{
  padding: 8px !important;
  height: 35px !important;
}

.particularCustomerDivCategoryCFS:focus {
  background-color: #e3e8ff !important;
  color: #0562fb !important;
  border: solid 1px #0562fb !important;
}

.dark .particularCustomerDivCategoryCFS {
  background-color: #353a50;
  color: white;
}

.light .particularCustomerDivCategoryCFS {
  background-color: white;
  color: black;
}

.particularActiveCategoryCFS{
  background-color: #0562fb !important;
  color: #fff !important;
  border: solid 1px #2A71FF;
  font-weight: 700 !important;
} */`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/tabModal/tabmodal2/index.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAyEG","sourcesContent":["/* .particularCategoryContainerCFS{\n  display: flex;\n  justify-content: flex-start;\n  overflow-x: auto !important;\n  margin-bottom: 0.5rem !important;\n  padding: 0.5rem !important;\n  gap: 7px !important;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.particularCategoryContainerCFS::-webkit-scrollbar {\n    display: none;\n}\n\n.particularCategoryContainerCFS::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3);\n  border-radius: 10px;\n  background-color: #f5f5f5;\n}\n.particularCategoryContainerCFS::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  background-color: #cbcbcb;\n}\n\n.light .particularCustomerDivCategoryCFS:focus {\n  outline: none;\n}\n\n.dark .particularCustomerDivCategoryCFS:focus {\n  outline: none;\n}\n\n.particularCustomerDivCategoryCFS{\n  border-radius: 5px;\n  font-size: 0.813rem !important;\n  font-weight: 400 !important;\n  border: 1px solid #2A71FF;\n  color: #2A71FF !important;\n  display: flex;\n  text-align: center !important;\n  align-items: center !important;\n  min-width: fit-content !important;\n  cursor: pointer;\n}\n\n.particularCategoryContainerCFS .particularCustomerDivCategoryCFS{\n  padding: 8px !important;\n  height: 35px !important;\n}\n\n.particularCustomerDivCategoryCFS:focus {\n  background-color: #e3e8ff !important;\n  color: #0562fb !important;\n  border: solid 1px #0562fb !important;\n}\n\n.dark .particularCustomerDivCategoryCFS {\n  background-color: #353a50;\n  color: white;\n}\n\n.light .particularCustomerDivCategoryCFS {\n  background-color: white;\n  color: black;\n}\n\n.particularActiveCategoryCFS{\n  background-color: #0562fb !important;\n  color: #fff !important;\n  border: solid 1px #2A71FF;\n  font-weight: 700 !important;\n} */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
